import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fb8231c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer" };
const _hoisted_2 = { class: "nav-container" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "item-container",
    style: { "margin-right": "290px" }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/ _createStaticVNode("<div class=\"nav-container\" data-v-1fb8231c><div class=\"item-container call-us\" data-v-1fb8231c><h2 class=\"title\" data-v-1fb8231c>联系我们</h2><p data-v-1fb8231c>北京诺信创联科技有限公司</p><p data-v-1fb8231c>地址：北京市朝阳区霄云里南街9号院华瑞大厦7层</p><a class=\"btn\" href=\"mailto: jianping.lin@naxions.com\" data-v-1fb8231c>邮箱：jianping.lin@naxions.com</a><p data-v-1fb8231c>电话：010-88862467</p></div><div class=\"item-container call-us\" data-v-1fb8231c><h2 class=\"title\" data-v-1fb8231c></h2><p data-v-1fb8231c>诺信创联上海分公司</p><p data-v-1fb8231c>地址：上海市浦东新区海阳西路555号前滩中心2204诺信创联</p><a class=\"btn\" href=\"mailto: jianping.lin@naxions.com\" data-v-1fb8231c>邮箱：jianping.lin@naxions.com</a><p data-v-1fb8231c>电话：010-88862467</p></div><div class=\"item-container call-us\" data-v-1fb8231c><h2 class=\"title\" data-v-1fb8231c></h2><p data-v-1fb8231c>诺信创联长沙分公司</p><p data-v-1fb8231c>地址：湖南省长沙市岳麓区麓谷新长海A2栋9层、9A层</p><a class=\"btn\" href=\"mailto: jianping.lin@naxions.com\" data-v-1fb8231c>邮箱：jianping.lin@naxions.com</a><p data-v-1fb8231c>电话：010-88862467</p></div></div><div class=\"remarks-container\" style=\"bottom:58px;\" data-v-1fb8231c> 北京诺信创联科技有限公司 | 工业和信息化部备案管理系统网站 <a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-1fb8231c>京ICP备15051719号-2</a> | 违法和不良信息举报电话：010-88862467 </div><div class=\"remarks-container\" data-v-1fb8231c>药品医疗器械网络信息服务备案 | 备案编号 (京)网药械信息备字(2022)第00493号</div><div class=\"m-remarks-container\" data-v-1fb8231c><div data-v-1fb8231c>药品医疗器械网络信息服务备案</div><div data-v-1fb8231c>备案编号 (京)网药械信息备字(2022)第00493号</div></div><div class=\"m-remarks-container\" data-v-1fb8231c><div data-v-1fb8231c>北京诺信创联科技有限公司</div><div data-v-1fb8231c>工业和信息化部备案管理系统网站</div><div data-v-1fb8231c><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-1fb8231c>京ICP备15051719号-2</a></div><div data-v-1fb8231c>违法和不良信息举报电话：010-88862467</div></div>", 5);
import { useRouter, onBeforeRouteUpdate } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const navList = [
            {
                title: '关于我们',
                list: [
                    {
                        name: '公司使命·愿景·价值观',
                        hash: '/#mission',
                    },
                    {
                        name: '公司简介',
                        hash: '/#introduction',
                    },
                    {
                        name: '大事记',
                        hash: '/#time-line',
                    },
                    {
                        name: '合作交流',
                        hash: '/#concat-us',
                    },
                ],
            },
            {
                title: '业务介绍',
                list: [
                    {
                        name: '业务简介',
                        hash: '/business#business',
                    },
                    {
                        name: '诺信价值',
                        hash: '/business#nax-data',
                    },
                    {
                        name: '覆盖疾病领域',
                        hash: '/business#nax-fields',
                    },
                    {
                        name: '业务覆盖范围',
                        hash: '/business#nax-map',
                    },
                ],
            },
        ];
        const router = useRouter();
        onBeforeRouteUpdate((to) => {
            if (to.hash) {
                router.push(to.path);
                setTimeout(() => {
                    const el = document.querySelector(to.hash);
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }, 200);
            }
        });
        function toUrl(url) {
            window.open(url);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navList, (item_o, index) => {
                        return _createElementVNode("div", {
                            key: index,
                            class: "item-container",
                            style: _normalizeStyle({ marginRight: index === 1 ? '115px' : '0px' })
                        }, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(item_o.title), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item_o.list, (item_i, index) => {
                                return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "btn",
                                    onClick: ($event) => (_unref(router).push(item_i.hash))
                                }, _toDisplayString(item_i.name), 9, _hoisted_4));
                            }), 128))
                        ], 4);
                    }), 64)),
                    _hoisted_5
                ]),
                _hoisted_6
            ]));
        };
    }
});
